import { render, staticRenderFns } from "./ordercheck.vue?vue&type=template&id=cdb8d326&scoped=true"
import script from "./ordercheck.vue?vue&type=script&lang=js"
export * from "./ordercheck.vue?vue&type=script&lang=js"
import style0 from "./ordercheck.vue?vue&type=style&index=0&id=cdb8d326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb8d326",
  null
  
)

export default component.exports